import { z } from "zod"

export const GROUPINGS = [
  "status",
  "priority",
  "customer",
  "department",
] as const

export const groupingSchema = z.enum(GROUPINGS)

export type Grouping = z.infer<typeof groupingSchema>

export const GROUPING_LABELS: Record<Grouping, string> = {
  status: "Status",
  priority: "Priority",
  customer: "Customer",
  department: "Department",
}
